import type { RoleConfig } from '../types.js';

export const detective: RoleConfig = {
  id: 'detective',
  faction: 'town',
  title: { ru: 'Детектив', uk: 'Детектив' },
  latin: 'DETECTIVE',
  number: '32',
  accent: '#5ac8e8',
  ability: {
    ru: 'Ночью узнаёт точную роль выбранного игрока — городская версия консильери.',
    uk: 'Вночі дізнається точну роль обраного гравця — міська версія консільєрі.',
  },
  abilities: [
    { key: 'inspect', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'town' },
};
